<template>
  <div class="team-list">
    <div class="team-item">
      <div class="box-shadow"></div>
      <div class="team-content">
        <div class="team-title">关于团队</div>
        <div class="team-desc">我们是一支年轻的团队，大家一起 大胆发挥，勇敢前进</div>
      </div>
      <div class="team-gif"/>
    </div>
    <div class="team-item">
      <div class="box-shadow"></div>
      <div class="team-content">
        <div class="team-title">关于福利</div>
        <div class="team-desc">员工福利，五险一金、周末双休 各种补贴、绩效奖金、年终奖</div>
      </div>
      <div class="team-gif2"/>
    </div>
    <div class="team-item">
      <div class="box-shadow"></div>
      <div class="team-content">
        <div class="team-title">关于工作</div>
        <div class="team-desc">平台足够大，通道足够多 弹性工作不打卡，自由</div>
      </div>
      <div class="team-gif3"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CTeam",
    data() {
      return {
        index: 0
      }
    }
  }
</script>

<style scoped>
  .team-list {
    display: flex;
    justify-content: center;
    margin-top: 94px;
    margin-bottom: 71px;
  }

  .team-item {
    padding: 61px 0 0 73px;
    background-image: url("../assets/bg_gytd2.png");
    width: 381px;
    height: 233px;
    margin: 0 20px;
    display: flex;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    transition: 0.3s ease-in-out;
  }

  .team-item:hover {
    background-image: url("../assets/bg_gywm2.png");
  }

  .team-item:hover .team-title, .team-item:hover .team-desc {
    color: #fff;
  }

  .box-shadow {
    position: absolute;
    top: -20px;
    left: -40px;
    background-image: url("../assets/bg_gywm.png");
    width: 461px;
    height: 313px;
    opacity: 0;
    z-index: -1;
    transition: 0.3s ease-in-out;
  }

  .team-item:hover .box-shadow {
    opacity: 1;
  }

  .team-title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4A4A4A;
    line-height: 29px;
    transition: color 0.3s ease-in-out;
  }

  .team-desc {
    width: 128px;
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: rgba(8, 20, 87, 0.53);
    line-height: 20px;
    transition: color 0.3s ease-in-out;
    margin-top: 20px;
  }

  .team-gif, .team-gif2, .team-gif3 {
    width: 121px;
    height: 121px;
    margin-left: 28px;
    transition: 0.2s ease-in-out;
    background-size: cover;
  }

  .team-gif {
    background-image: url("../assets/icon_gytd2.png");
  }

  .team-gif2 {
    background-image: url("../assets/icon_gyfl2.png");
  }

  .team-gif3 {
    background-image: url("../assets/icon_gygz2.png");
  }

  .team-item:hover .team-gif {
    background-image: url("../assets/icon_td.png");
  }

  .team-item:hover .team-gif2 {
    background-image: url("../assets/ico_fl.png");
  }

  .team-item:hover .team-gif3 {
    background-image: url("../assets/icon_gz.png");
  }

</style>



// WEBPACK FOOTER //
// src/components/CTeam.vue